import { render, staticRenderFns } from "./buttonConfirm.vue?vue&type=template&id=b9b74ada&"
import script from "./buttonConfirm.vue?vue&type=script&lang=js&"
export * from "./buttonConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports